export default "__VITE_ASSET__ui3R9uF9__"